export default __webpack_public_path__ + "images/314f0c922c692a4cfaececcf3d212318.png";